'use client'

import React from 'react'
import { X } from 'lucide-react'
import { IconButton } from '@material-tailwind/react'

interface ExternalWebsiteSidebarProps {
  isOpen: boolean
  onClose: () => void
  url: string
}

const ExternalWebsiteSidebar: React.FC<ExternalWebsiteSidebarProps> = ({
  isOpen,
  onClose,
  url
}) => {
  if (!isOpen) return null

  return (
    <>
      {/* Mobile Overlay */}
      <div className="lg:hidden">
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50" onClick={onClose} />
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="relative h-full w-full max-w-md bg-white rounded-lg overflow-hidden">
            <div className="flex items-center justify-between p-4 border-b">
              <h3 className="text-lg font-semibold">Step by Step Guidance</h3>
              <IconButton variant="text" onClick={onClose}>
                <X size={20} />
              </IconButton>
            </div>
            <iframe
              src={url}
              className="w-full h-[calc(100%-64px)]"
              title="External Website"
            />
          </div>
        </div>
      </div>

      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <div
          className={`fixed right-0 top-16 h-[calc(100vh-64px)] w-96 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${
            isOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex items-center justify-between p-4 border-b">
            <h3 className="text-lg font-semibold">Step by Step Guidance</h3>
            <IconButton variant="text" onClick={onClose}>
              <X size={20} />
            </IconButton>
          </div>
          <iframe
            src={url}
            className="w-full h-[calc(100%-64px)]"
            title="External Website"
          />
        </div>
      </div>
    </>
  )
}

export default ExternalWebsiteSidebar